module.exports = __webpack_public_path__ + "static/stretching-the-school-dollar-490711e0eb5c6fb55907aa71d070dca3.jpg";